<template>
	<div class="quality-alerts-view pa-4">
		<!-- 1. Encabezado del Módulo (Tarjeta Neutra Limpia) -->
		<v-card class="mb-4 rounded-xl border-light bg-white" outlined elevation="0">
			<v-card-title class="d-flex align-center py-4 px-5 flex-wrap">
				<v-avatar color="amber lighten-5" size="48" class="mr-3">
					<v-icon color="amber darken-3" large>mdi-bell-ring-outline</v-icon>
				</v-avatar>
				<div>
					<h2 class="text-h6 font-weight-black grey--text text--darken-4 mb-0">
						Alertador de Calidad - Vencimiento de Análisis
					</h2>
					<span class="text-caption grey--text text--darken-2">
						Monitoreo, control y emisión de solicitudes de re-muestreo para análisis de materia prima próximos a vencer (≤ 15 días) o vencidos.
					</span>
				</div>
				<v-spacer></v-spacer>
				<v-btn color="primary" class="text-capitalize rounded-lg font-weight-bold" elevation="0" @click="fetchData">
					<v-icon left>mdi-refresh</v-icon>
					Actualizar Alertas
				</v-btn>
			</v-card-title>
		</v-card>

		<!-- 2. Tarjeta de Filtros de Búsqueda -->
		<v-card class="mb-3 rounded-xl border-light bg-white" outlined elevation="0">
			<v-card-title class="py-2 px-4 d-flex align-center flex-wrap">
				<v-icon color="grey darken-3" small class="mr-2">mdi-filter-variant</v-icon>
				<span class="text-subtitle-2 font-weight-bold grey--text text--darken-4 text-uppercase">
					FILTROS DE BÚSQUEDA
				</span>
			</v-card-title>
			<v-divider></v-divider>

			<v-card-text class="py-3 px-4">
				<v-row dense align="center">
					<v-col cols="12" sm="6" md="2">
						<s-date
							clearable
							v-model="filters.BeginDate"
							label="Fec. Venc. Inicio"
							@change="fetchData"
						></s-date>
					</v-col>
					<v-col cols="12" sm="6" md="2">
						<s-date
							clearable
							v-model="filters.EndDate"
							label="Fec. Venc. Fin"
							@change="fetchData"
						></s-date>
					</v-col>
					<v-col cols="12" sm="6" md="5">
						<s-select-campaign-area
							clearable
							no-default
							typeArea="1"
							v-model="filters.CmaID"
							label="Campaña"
							@change="fetchData"
						></s-select-campaign-area>
					</v-col>
					<v-col cols="12" sm="6" md="3">
						<s-select-definition
							clearable
							:def="1173"
							v-model="filters.TypeCultive"
							label="Cultivo"
							@change="fetchData"
						></s-select-definition>
					</v-col>
				</v-row>

				<v-row dense align="center" class="mt-1">
					<v-col cols="12" sm="6" md="4">
						<s-select-lot
							clearable
							no-default
							full
							v-model="filters.FltID"
							label="Sub Lote"
							@change="fetchData"
						></s-select-lot>
					</v-col>
					<v-col cols="12" sm="6" md="8" class="text-right d-flex align-center justify-end py-0">
						<v-btn color="primary" small class="rounded-lg font-weight-bold white--text text-none px-5 mr-2" elevation="0" height="34" @click="fetchData">
							<v-icon left x-small>mdi-magnify</v-icon>
							Consultar
						</v-btn>
						<v-btn text small color="grey darken-2" class="rounded-lg text-none px-3" height="34" @click="clearFilters">
							Limpiar
						</v-btn>
					</v-col>
				</v-row>
			</v-card-text>
		</v-card>

		<!-- 3. Tarjetas KPI Resumen (4 Tarjetas en fila) -->
		<v-row dense class="mb-5">
			<v-col cols="12" sm="6" md="3">
				<v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
					<div class="d-flex align-center">
						<v-avatar color="grey lighten-4" size="42" class="mr-3">
							<v-icon color="grey darken-3">mdi-clipboard-list-outline</v-icon>
						</v-avatar>
						<div>
							<div class="text-caption text-uppercase font-weight-bold grey--text text--darken-2">
								TOTAL ALERTAS
							</div>
							<div class="text-h6 font-weight-black grey--text text--darken-4">
								{{ totalRecords }}
							</div>
						</div>
					</div>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
					<div class="d-flex align-center">
						<v-avatar color="red lighten-5" size="42" class="mr-3">
							<v-icon color="red darken-2">mdi-alert-circle</v-icon>
						</v-avatar>
						<div>
							<div class="text-caption text-uppercase font-weight-bold red--text text--darken-2">
								ANÁLISIS VENCIDOS
							</div>
							<div class="text-h6 font-weight-black red--text text--darken-3">
								{{ countExpired }}
							</div>
						</div>
					</div>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
					<div class="d-flex align-center">
						<v-avatar color="amber lighten-5" size="42" class="mr-3">
							<v-icon color="amber darken-3">mdi-clock-alert-outline</v-icon>
						</v-avatar>
						<div>
							<div class="text-caption text-uppercase font-weight-bold amber--text text--darken-4">
								POR VENCER (≤ 15 DÍAS)
							</div>
							<div class="text-h6 font-weight-black amber--text text--darken-4">
								{{ countAboutToExpire }}
							</div>
						</div>
					</div>
				</v-card>
			</v-col>

			<v-col cols="12" sm="6" md="3">
				<v-card class="rounded-xl pa-3 bg-white border-light" outlined elevation="0">
					<div class="d-flex align-center">
						<v-avatar color="teal lighten-5" size="42" class="mr-3">
							<v-icon color="teal darken-3">mdi-clock-outline</v-icon>
						</v-avatar>
						<div>
							<div class="text-caption text-uppercase font-weight-bold teal--text text--darken-3">
								SOLICITADOS EN PROCESO
							</div>
							<div class="text-h6 font-weight-black teal--text text--darken-4">
								{{ countRequested }}
							</div>
						</div>
					</div>
				</v-card>
			</v-col>
		</v-row>

		<!-- 4. Data Table con el Stored Procedure de Calidad -->
		<v-card class="rounded-xl border-light bg-white pa-4 mb-5" outlined elevation="0">
			<div class="d-flex align-center justify-space-between mb-3 flex-wrap">
				<div class="d-flex align-center mb-2 mb-md-0">
					<v-icon color="grey darken-3" class="mr-2">mdi-table-large</v-icon>
					<span class="text-subtitle-1 font-weight-black grey--text text--darken-4 text-uppercase">
						ALERTAS Y VENCIMIENTOS DE ANÁLISIS
					</span>
				</div>

				<div class="d-flex align-center flex-wrap" style="gap: 12px;">
					<v-btn-toggle v-model="filterType" mandatory dense class="rounded-lg border bg-white">
						<v-btn small value="ALL" class="text-capitalize">
							Todas ({{ itemsList.length }})
						</v-btn>
						<v-btn small value="EXPIRED" class="text-capitalize red--text font-weight-bold">
							Vencidos ({{ countExpired }})
						</v-btn>
						<v-btn small value="WARNING" class="text-capitalize amber--text text--darken-4">
							Por Vencer ({{ countAboutToExpire }})
						</v-btn>
						<v-btn small value="REQUESTED" class="text-capitalize teal--text text--darken-3 font-weight-bold">
							Solicitados ({{ countRequested }})
						</v-btn>
					</v-btn-toggle>

					<v-text-field
						v-model="search"
						append-icon="mdi-magnify"
						placeholder="Buscar en la grilla..."
						single-line
						hide-details
						dense
						outlined
						clearable
						class="bg-white"
						style="max-width: 260px;"
						@keyup.enter="fetchData"
						@click:clear="fetchData"
					></v-text-field>
				</div>
			</div>

			<v-data-table
				:headers="headers"
				:items="filteredItems"
				:loading="loading"
				loading-text="Consultando alertas de vencimiento desde SQL Server..."
				no-data-text="No hay análisis por vencer ni vencidos registrados"
				dense
				class="border-rounded elevation-0"
			>
				<!-- Columna Estado Validez -->
				<template v-slot:item.ExpirationStatus="{ item }">
					<v-chip
						x-small
						:color="getExpirationStatusColor(item)"
						dark
						v-if="getExpirationDays(item) !== null"
					>
						<v-icon x-small left>{{ getExpirationStatusIcon(item) }}</v-icon>
						{{ getExpirationStatusText(item) }}
					</v-chip>
					<span v-else class="caption grey--text">Sin Fecha</span>
				</template>

				<!-- Columna Lote -->
				<template v-slot:item.FltName="{ item }">
					<div>
						<span class="font-weight-bold text-body-2">{{ item.FltName || '-' }}</span>
						<span class="caption grey--text d-block">ID Lote: {{ item.FltID }}</span>
					</div>
				</template>

				<!-- Columna Fechas -->
				<template v-slot:item.ResultsIssueDate="{ item }">
					<span class="caption">
						{{ item.ResultsIssueDate ? $moment(item.ResultsIssueDate).format("DD/MM/YYYY") : '-' }}
					</span>
				</template>

				<template v-slot:item.ExpirationDate="{ item }">
					<span class="caption font-weight-medium">
						{{ getExpirationDateFormatted(item) }}
					</span>
				</template>

				<!-- Columna Dictamen LMR -->
				<template v-slot:item.TypeStatusApprovalsName="{ item }">
					<v-chip
						x-small
						:color="getHeaderStatusColor(item)"
						dark
					>
						{{ item.TypeStatusApprovalsName || 'PENDIENTE' }}
					</v-chip>
				</template>

				<!-- Columna Acciones de Calidad -->
				<template v-slot:item.actions="{ item }">
					<v-chip
						v-if="item.PendingRmrID || item.pendingRmrID"
						small
						color="amber darken-4"
						dark
						class="font-weight-bold"
					>
						<v-icon left small>mdi-clock-outline</v-icon>
						Solicitado (En Proceso)
					</v-chip>
					<v-btn
						v-else
						small
						color="primary"
						class="text-capitalize font-weight-bold elevation-1"
						@click="openRequestModal(item)"
					>
						<v-icon left small>mdi-flask-empty-plus</v-icon>
						Solicitar Nuevo Análisis
					</v-btn>
				</template>
			</v-data-table>
		</v-card>

		<!-- Modal Dialog: Instrucciones de Calidad para Operaciones Agrícolas -->
		<v-dialog v-model="dialogRequestModal" max-width="580px" persistent>
			<v-card class="rounded-lg">
				<v-card-title class="headline blue darken-3 white--text py-3 px-4">
					<v-icon color="white" left>mdi-flask-empty-plus</v-icon>
					<span style="font-weight: 600; font-size: 1.1rem">
						Solicitar Re-Muestreo a Operaciones Agrícolas
					</span>
					<v-spacer></v-spacer>
					<v-btn icon dark @click="dialogRequestModal = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>

				<v-card-text class="pa-4" v-if="selectedLotItem">
					<v-alert type="info" text dense class="mb-3">
						Esta orden notificará a Operaciones Agrícolas indicando que se requiere generar un nuevo análisis para este lote.
					</v-alert>

					<!-- Resumen del Lote -->
					<v-row dense class="grey lighten-4 pa-3 rounded-lg mb-3">
						<v-col cols="6">
							<span class="caption grey--text text--darken-2 d-block">Lote / Fundo:</span>
							<span class="font-weight-bold text-subtitle-2">{{ selectedLotItem.FltName }} ({{ selectedLotItem.FagName }})</span>
						</v-col>
						<v-col cols="6">
							<span class="caption grey--text text--darken-2 d-block">Productor:</span>
							<span class="font-weight-bold text-subtitle-2">{{ selectedLotItem.PrdCardName }}</span>
						</v-col>
						<v-col cols="6" class="mt-2">
							<span class="caption grey--text text--darken-2 d-block">Análisis / Matriz:</span>
							<span>{{ selectedLotItem.TypeAnalysisName }} / {{ selectedLotItem.TypeMatrixName }}</span>
						</v-col>
						<v-col cols="6" class="mt-2">
							<span class="caption grey--text text--darken-2 d-block">Estado Validez:</span>
							<span class="red--text font-weight-bold" v-if="getExpirationDays(selectedLotItem) < 0">
								🔴 VENCIDO (hace {{ Math.abs(getExpirationDays(selectedLotItem)) }}d)
							</span>
							<span class="amber--text text--darken-4 font-weight-bold" v-else>
								🟡 POR VENCER ({{ getExpirationDays(selectedLotItem) }}d restantes)
							</span>
						</v-col>
					</v-row>

					<!-- Campos de la Solicitud -->
					<v-row dense>
						<v-col cols="12" md="6">
							<v-select
								v-model="requestForm.priority"
								:items="priorityOptions"
								label="Prioridad de Solicitud"
								dense
								outlined
							></v-select>
						</v-col>
						<v-col cols="12" md="6">
							<v-text-field
								v-model="requestForm.targetDate"
								type="date"
								label="Fecha Límite Sugerida"
								dense
								outlined
							></v-text-field>
						</v-col>
						<v-col cols="12">
							<v-textarea
								v-model="requestForm.observation"
								label="Instrucción / Observación para Operaciones Agrícolas"
								placeholder="Ej. Realizar toma de muestra urgente en campo para actualización de LMR por vencimiento."
								rows="3"
								dense
								outlined
							></v-textarea>
						</v-col>
					</v-row>
				</v-card-text>

				<v-card-actions class="pa-3 grey lighten-3">
					<v-spacer></v-spacer>
					<v-btn text @click="dialogRequestModal = false" class="text-capitalize">
						Cancelar
					</v-btn>
					<v-btn color="primary" class="text-capitalize px-4 font-weight-bold" @click="sendRequestToOperations">
						<v-icon left small>mdi-send</v-icon>
						Enviar Solicitud a Operaciones
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
import _sService from "@/services/Technicalassistance/TasRawMaterialAnalysisService";
import SSelectLot from "@/components/HarvestSchedule/SSelectLot.vue";

export default {
	name: "QualityAlertsView",
	components: {
		SSelectLot,
	},
	data: () => ({
		loading: false,
		search: "",
		filterType: "ALL",
		filters: {
			BeginDate: null,
			EndDate: null,
			CmaID: null,
			FltID: null,
			TypeCultive: null,
		},
		itemsList: [],
		totalRecords: 0,
		dialogRequestModal: false,
		selectedLotItem: null,
		priorityOptions: [
			{ text: "Normal", value: "NORMAL" },
			{ text: "Alta (Próximo Vencimiento)", value: "ALTA" },
			{ text: "Urgente (Lote Vencido)", value: "URGENTE" },
		],
		requestForm: {
			priority: "ALTA",
			targetDate: null,
			observation: "",
		},
		headers: [
			{ text: "Estado Validez", value: "ExpirationStatus", width: "140", align: "center", sortable: true },
			{ text: "ID", value: "RmnID", width: "60", align: "center", sortable: true },
			{ text: "Lote", value: "FltName", width: "110", sortable: true },
			{ text: "Fundo", value: "FagName", width: "140", sortable: true },
			{ text: "Productor", value: "PrdCardName", width: "170", sortable: true },
			{ text: "Tipo Análisis", value: "TypeAnalysisName", width: "130", sortable: true },
			{ text: "Tipo Matriz", value: "TypeMatrixName", width: "110", sortable: true },
			{ text: "Dictamen LMR", value: "TypeStatusApprovalsName", width: "130", align: "center", sortable: true },
			{ text: "Fec. Emisión", value: "ResultsIssueDate", width: "110", align: "center", sortable: true },
			{ text: "Fec. Vencimiento", value: "ExpirationDate", width: "120", align: "center", sortable: true },
			{ text: "Acciones Calidad", value: "actions", width: "185", align: "center", sortable: false },
		],
	}),
	computed: {
		countExpired() {
			return this.itemsList.filter((x) => {
				const d = this.getExpirationDays(x);
				return d !== null && d < 0;
			}).length;
		},
		countAboutToExpire() {
			return this.itemsList.filter((x) => {
				const d = this.getExpirationDays(x);
				return d !== null && d >= 0 && d <= 15;
			}).length;
		},
		countRequested() {
			return this.itemsList.filter((x) => !!(x.PendingRmrID || x.pendingRmrID)).length;
		},
		filteredItems() {
			if (this.filterType === "EXPIRED") {
				return this.itemsList.filter((x) => {
					const d = this.getExpirationDays(x);
					return d !== null && d < 0;
				});
			} else if (this.filterType === "WARNING") {
				return this.itemsList.filter((x) => {
					const d = this.getExpirationDays(x);
					return d !== null && d >= 0 && d <= 15;
				});
			} else if (this.filterType === "REQUESTED") {
				return this.itemsList.filter((x) => !!(x.PendingRmrID || x.pendingRmrID));
			}
			return this.itemsList;
		},
	},
	mounted() {
		this.fetchData();
	},
	methods: {
		clearFilters() {
			this.filters.BeginDate = null;
			this.filters.EndDate = null;
			this.filters.CmaID = null;
			this.filters.FltID = null;
			this.filters.TypeCultive = null;
			this.search = "";
			this.fetchData();
		},
		async fetchData() {
			this.loading = true;
			try {
				const dtr = {
					draw: 1,
					start: 0,
					length: 500,
					orderColumn: "RmnID",
					orderDir: "DESC",
					searchText: this.search || "",
					filter: JSON.stringify({
						BeginDate: this.filters.BeginDate || null,
						EndDate: this.filters.EndDate || null,
						CmaID: this.filters.CmaID || null,
						FltID: this.filters.FltID || null,
						TypeCultive: this.filters.TypeCultive || null,
					}),
				};
				const userId = this.$fun ? this.$fun.getUserID() : 1;
				const res = await _sService.qualityAlertsPagination(dtr, userId);
				if (res && res.status === 200) {
					let list = [];
					if (res.data && Array.isArray(res.data.data)) {
						list = res.data.data;
						this.totalRecords = res.data.recordsTotal || list.length;
					} else if (Array.isArray(res.data)) {
						list = res.data;
						this.totalRecords = list.length;
					}
					this.itemsList = list;
				}
			} catch (e) {
				console.error("Error fetching quality alerts procedure", e);
			} finally {
				this.loading = false;
			}
		},
		getExpirationDays(row) {
			if (!row) return null;
			let expStr = row.ExpirationDate;
			if (!expStr && row.ResultsIssueDate) {
				try {
					const d = new Date(row.ResultsIssueDate);
					if (!isNaN(d.getTime())) {
						d.setDate(d.getDate() + 30);
						expStr = d.toISOString().substring(0, 10);
					}
				} catch (e) {
					console.error(e);
				}
			}
			if (!expStr) return null;
			const exp = new Date(String(expStr).substring(0, 10) + "T00:00:00");
			if (isNaN(exp.getTime())) return null;

			const today = new Date();
			today.setHours(0, 0, 0, 0);

			const diffMs = exp.getTime() - today.getTime();
			return Math.ceil(diffMs / (1000 * 60 * 60 * 24));
		},
		getExpirationDateFormatted(row) {
			if (!row) return "-";
			let expStr = row.ExpirationDate;
			if (!expStr && row.ResultsIssueDate) {
				try {
					const d = new Date(row.ResultsIssueDate);
					if (!isNaN(d.getTime())) {
						d.setDate(d.getDate() + 30);
						return this.$moment(d).format("DD/MM/YYYY");
					}
				} catch (e) {
					console.error(e);
				}
			}
			return expStr ? this.$moment(expStr).format("DD/MM/YYYY") : "-";
		},
		getExpirationStatusColor(row) {
			const days = this.getExpirationDays(row);
			if (days === null) return "grey";
			if (days < 0) return "error";
			if (days <= 15) return "warning darken-1";
			return "success";
		},
		getExpirationStatusIcon(row) {
			const days = this.getExpirationDays(row);
			if (days === null) return "mdi-clock-outline";
			if (days < 0) return "mdi-alert-circle";
			if (days <= 15) return "mdi-clock-alert-outline";
			return "mdi-check-circle-outline";
		},
		getExpirationStatusText(row) {
			const days = this.getExpirationDays(row);
			if (days === null) return "Sin Fecha";
			if (days < 0) return `Vencido (${Math.abs(days)}d)`;
			if (days === 0) return "Vence Hoy";
			if (days <= 15) return `Por Vencer (${days}d)`;
			return `Vigente (${days}d)`;
		},
		getHeaderStatusColor(row) {
			const name = String(row.TypeStatusApprovalsName || "").toUpperCase();
			if (name.includes("NO CONFORME") || name.includes("RECHAZ")) return "error";
			if (name.includes("RESTRING")) return "orange darken-2";
			if (name.includes("APROBADO") || name.includes("LIBRE")) return "success";
			return "blue-grey darken-1";
		},
		openRequestModal(item) {
			const pendingId = item.PendingRmrID || item.pendingRmrID;
			if (pendingId) {
				this.$fun.alert(
					`El lote ${item.FltName || ''} ya cuenta con la Solicitud N° ${pendingId} en proceso con Operaciones Agrícolas.`,
					"warning"
				);
				return;
			}
			this.selectedLotItem = item;
			const days = this.getExpirationDays(item);
			const isExpired = days !== null && days < 0;
			this.requestForm.priority = isExpired ? "URGENTE" : "ALTA";
			this.requestForm.observation = isExpired
				? `SOLICITUD URGENTE: El análisis de ${item.TypeAnalysisName || "MP"} para el lote ${item.FltName || ""} ha vencido.`
				: `SOLICITUD PREVENTIVA: El análisis vencerá en ${days} días. Se requiere tomar nuevo muestreo en el fundo ${item.FagName || ""}.`;

			const t = new Date();
			t.setDate(t.getDate() + 3);
			this.requestForm.targetDate = t.toISOString().substring(0, 10);

			this.dialogRequestModal = true;
		},
		sendRequestToOperations() {
			if (!this.selectedLotItem) return;

			const obj = {
				RmnID_Original: this.selectedLotItem.RmnID || 0,
				CmaID: this.selectedLotItem.CmaID || 0,
				FltID: this.selectedLotItem.FltID || 0,
				TypeAnalysis: this.selectedLotItem.TypeAnalysis || 0,
				TypeMatrix: this.selectedLotItem.TypeMatrix || 0,
				RequestPriority: this.requestForm.priority || "NORMAL",
				RequestTargetDate: this.requestForm.targetDate || null,
				RequestObservation: this.requestForm.observation || "",
			};

			const userId = this.$fun ? this.$fun.getUserID() : 1;
			_sService.requestSave(obj, userId).then((res) => {
				if (res && res.status === 200) {
					const generatedRmrID = (res.data && (res.data.RmrID || res.data.rmrID)) || 1;
					this.$set(this.selectedLotItem, 'PendingRmrID', generatedRmrID);
					this.$set(this.selectedLotItem, 'pendingRmrID', generatedRmrID);

					this.$fun.alert(
						`Solicitud guardada en la tabla intermedia y enviada a Operaciones Agrícolas para el lote ${this.selectedLotItem.FltName}.`,
						"success"
					);
					this.dialogRequestModal = false;
					this.fetchData();
				}
			}).catch((err) => {
				this.$fun.alert("Error al guardar la solicitud: " + (err.message || err), "error");
			});
		},
	},
};
</script>

<style scoped>
.border-light {
	border: 1px solid #e2e8f0 !important;
}
.border-rounded {
	border-radius: 8px !important;
}
.border-error {
	border-left: 4px solid #d32f2f !important;
}
.border-warning {
	border-left: 4px solid #ffb300 !important;
}
.border-info {
	border-left: 4px solid #1976d2 !important;
}
.bg-white {
	background-color: #ffffff !important;
}
</style>
